module.exports = __webpack_public_path__ + "img/banner1.2cd858f3.jpg";